/**
 * Configuration for Physics Simulator
 * 
 * Public configuration - safe to expose in client code
 */

// Supabase configuration
// The anon key is safe to expose - it's protected by Row Level Security (RLS)
// Get it from: https://supabase.com/dashboard/project/xougqdomkoisrxdnagcj/settings/api
export const CONFIG = {
  supabaseUrl: 'https://xougqdomkoisrxdnagcj.supabase.co',
  supabaseAnonKey: null, // Set via window.SUPABASE_ANON_KEY or environment
  matrixServer: 'https://matrix.castalia.institute',
  facultyId: 'a.newton',
  physicsWebUrl: window.location.origin, // Current site URL
}

// Allow override from window config
if (typeof window !== 'undefined' && window.PHYSICS_CONFIG) {
  Object.assign(CONFIG, window.PHYSICS_CONFIG)
}

// Set anon key from window if available
if (typeof window !== 'undefined' && window.SUPABASE_ANON_KEY) {
  CONFIG.supabaseAnonKey = window.SUPABASE_ANON_KEY
}
